<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：门店-店员列表-添加店员
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--添加店员-->
      <div class="common-form">添加城市代理</div>
      <el-form-item label="代理账号名称" prop="supplier.name" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.name" placeholder="请输入代理账号名称"></el-input>
      </el-form-item>
      <el-form-item label="登录账号" prop="supplier.user_name" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.user_name" placeholder="请输入账号"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="supplier.password" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.supplier.password" placeholder="请输入登录密码" type="password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="supplier.confirm_password" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.supplier.confirm_password" placeholder="请输入确认密码" type="password"
          class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="分成比例" prop="supplier.scale" :rules="[{ required: true, message: ' ' }]">
        <el-input v-model="form.supplier.scale" placeholder="请输入分成比例" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="supplier.link_name" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.link_name" placeholder="请输入联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="supplier.link_phone" :rules="[{ required: true, message: ' ' }]">
        <el-input class="max-w460" v-model="form.supplier.link_phone" placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="头像图片">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('logo')">选择图片</el-button>
          <div v-if="form.supplier.logo_id != ''" class="img">
            <img :src="logo_filePath" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="选择代理类型">
        <el-radio-group v-model="form.supplier.supplier_type">
          <el-radio label="2">市代</el-radio>
          <el-radio label="3">区代</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="代理城市" :rules="[{ required: true, message: ' ' }]">
        <!-- <el-select v-model="form.supplier.agent_city_ids" placeholder="请选择" multiple>
          <el-option v-for="(item, index) in citydata" :key="index" :label="item.city" :disabled="item.type"
            :value="item.city_id"></el-option>
        </el-select> -->
        <el-cascader :options="citydata" :props="{ value: 'id', label: 'label', checkStrictly: true }" clearable
          v-model="form.supplier.agent_city_ids"></el-cascader>
      </el-form-item>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--管理用户-->
    <GetUser :is_open="open_user" @close="closeDialogFunc($event, 'add')"></GetUser>
  </div>
</template>

<script>
import CityagencyApi from "@/api/cityagency.js";
import Upload from "@/components/file/Upload";
import GetUser from "@/components/user/GetUser.vue";
export default {
  components: {
    /*上传组件*/
    Upload,
    /*选择用户*/
    GetUser
  },
  data() {
    return {
      /*form表单数据*/
      /*左边长度*/
      formLabelWidth: "180px",
      form: {
        supplier: {
          logo_id: 0,
          user_name: '',
          password: '',
          name: '',
          confirm_password: '',
          link_name: '',
          link_phone: '',
          agent_city_ids: "",
          supplier_type: '2'

        }
      },
      logo_filePath: "",
      business_filePath: "",
      /*是否打开添加弹窗*/
      open_add: false,
      storeList: [],
      category: [],
      citydata: [],
      service_type: [],
      /*是否上传图片*/
      isupload: false,
      loading: false,
      type: "logo",
      open_user: false,
      user_info: {}
    };
  },
  created() {
    /*获取列表*/
    this.getCategoryList();
  },
  methods: {
    /*获取类别*/
    getCategoryList() {
      let self = this;
      let Params = {};
      CityagencyApi.getCityagency(Params, true)
        .then(res => {
          console.log(res.data)
          self.citydata = res.data.map(item => {
            if (item.type == 1) {
              return { ...item, type: false };
            } else {
              return { ...item, type: true };

            }
          });
          console.log(self.citydata, '数据')
          self.citydata.forEach((item, index) => {
            item.children = item.citys
            item.label = item.province
            item.id = item.provinceId
            if (item.children) {
              item.children.forEach(subItem => {
                subItem.children = subItem.regions
                subItem.label = subItem.city
                subItem.id = subItem.cityId
                if (subItem.children) {
                  subItem.children.forEach(yItem => {
                    yItem.label = yItem.name
                  })
                }
              })
            }

            // console.log(item)
          })

        })
        .catch(error => { });
    },
    onSubmit() {
      let self = this;
      let agent_city_ids = ''

      let mylength = 0
      if (this.form.supplier.agent_city_ids.length == 0) {
        this.$message({
          message: "请选择代理城市",
          type: "error"
        });
        return
      }
      if (this.form.supplier.agent_city_ids) {
        console.log(this.form.supplier.agent_city_ids,9090123)
        mylength = this.form.supplier.agent_city_ids.length
        console.log(mylength, '长度')
        if (mylength <= 1) {
          this.$message({
            message: "请选择市级或区级城市代理",
            type: "error"
          });
          return
        } else {
          agent_city_ids = this.form.supplier.agent_city_ids[mylength - 1]
          // console.log(agent_city_ids)
          console.log(mylength)
          if (self.form.supplier.supplier_type == 2) {
            if (mylength != 2) {
              self.$message({
                message: "您的代理类型为市级代理，请选择市级城市",
                type: "error"
              });
              return
            }
          }
          if (self.form.supplier.supplier_type == 3) {
            if (mylength != 3) {
              self.$message({
                message: "您的代理类型为区级代理，请选择区级城市",
                type: "error"
              });
              return
            }
          }
          // console.log(this.form.supplier.agent_city_ids[mylength - 1])
          // agent_city_ids = this.form.supplier.agent_city_ids[mylength - 1]
          // if (mylength == 2) {
          //   supplier_type = 2
          // } else {
          //   supplier_type = 3
          // }
        }

      }
      // let agent_city_ids = "";
      // if (self.form.supplier.agent_city_ids.length > 0) {
      //   agent_city_ids = self.form.supplier.agent_city_ids.join(",");
      // } else {
      //   agent_city_ids = "";
      // }
       let form = self.form.supplier;
       form.agent_city_ids = agent_city_ids;
      // form.supplier_type = supplier_type
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CityagencyApi.addCityagency(form, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: "恭喜你，添加成功",
                  type: "success"
                });
                self.$router.push("/cityagency/cityagency/index");
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.form.supplier.agent_city_ids = ''
              self.loading = false;
            });
        } else {
          self.form.supplier.agent_city_ids = ''
        }
      });
    },

    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.type == "logo") {
          this.logo_filePath = e[0].filePath;
          this.form.supplier.logo_id = e[0].fileId;
        }
      }
      this.isupload = false;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*打开弹出层*/
    userClick() {
      this.open_user = true;
    },

    /*关闭获取用户弹窗*/
    closeDialogFunc(e) {
      if (e.type != "error") {
        this.user_info = e.params[0];
        this.form.supplier.user_id = e.params[0].user_id;
      }
      this.open_user = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-add {
  padding-bottom: 50px;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/cityagency/cityagency/add.vue